var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorkBagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9954 15.2865V12.9609",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.6738 4.89062C18.223 4.89062 19.4697 6.14646 19.4697 7.69562V10.849C17.2147 12.169 14.2355 12.9665 10.9905 12.9665C7.74551 12.9665 4.77551 12.169 2.52051 10.849V7.68646C2.52051 6.13729 3.77634 4.89062 5.32551 4.89062H16.6738Z",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2038 4.88477V4.54927C14.2038 3.43094 13.2963 2.52344 12.1779 2.52344H9.81294C8.69461 2.52344 7.78711 3.43094 7.78711 4.54927V4.88477",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.54297 14.1953L2.71622 16.4952C2.83355 18.0453 4.12514 19.2434 5.67889 19.2434H16.3113C17.8651 19.2434 19.1566 18.0453 19.274 16.4952L19.4472 14.1953",
    stroke: "#666666",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkBagIcon);
export default __webpack_public_path__ + "static/media/workBagIcon.70dff352ce414294281a5e0bd906731b.svg";
export { ForwardRef as ReactComponent };